<div *ngIf="expiresInSeconds && session && session.identity">
  You are currently logged in as
  <a class="link-underline link-underline-opacity-0" [routerLink]="accountDetailsRouterLink">{{session.identity.sub}}</a>.
  Your session expires in <uptime-view [seconds]="expiresInSeconds"></uptime-view>
</div>

